import { TrapActivityType } from 'api/traps/SRBMTraps/types';
import { StatusTypes } from 'api/traps/types';

enum TrapTypeMonitoring {
  SMST = 'smst',
  SRST = 'srst',
  MCT = 'mct',
  SRBM = 'srbm',
}

interface SignalTime {
  amount: number;
  inner_time: string;
  status: StatusTypes;
  approved_at?: string;
}

interface Signal {
  date: string;
  time: SignalTime[];
}

interface Trap {
  sequence_number: number | null;
  serial_number: string;
  date_of_installation: string | null;
  remove_date: string;
  signals: Signal[];
}

type reportMCTMonitoringApiResponse = Trap[];

interface SBSSignalTime {
  inner_time: string;
  bait_filling: string;
  added_bait: string;
  bait_replacement: boolean;
  eaten_bait: string;
  activity_type: TrapActivityType;
}

interface SBSSignal {
  date: string;
  time: SBSSignalTime[];
}

interface SBSTrap {
  sequence_number: number | null;
  serial_number: string;
  date_of_installation: string | null;
  remove_date: string;
  used_poison: string;
  signals: SBSSignal[];
}

type reportSBSMonitoringApiResponse = SBSTrap[];

interface TriggerCounts {
  empty: number;
  caught: number;
  rejected: number;
  unknown?: number;
}

interface SignalTime {
  amount: number;
  inner_time: string; // "HH:mm:ss" or "---"
  action_type: StatusTypes;
}

interface SignalDay {
  date: string; // "YYYY-MM-DD"
  time: SignalTime[];
  action_count: number;
  counts?: TriggerCounts;
}

interface SnapData {
  enter: string; // "L" | "R"
  sequence_number: string;
  signals: SignalDay[];
  totals?: TriggerCounts;
}

interface STMonitoring {
  date_of_installation: string | null;
  serial_number: string;
  snaps: SnapData[];
}

type reportSTMonitoringApiResponse = STMonitoring[];

export {
  reportMCTMonitoringApiResponse,
  reportSBSMonitoringApiResponse,
  reportSTMonitoringApiResponse,
  SignalTime,
  TrapTypeMonitoring,
};
